export const formatAmount = (amount: number | string, round = true) => {
    let formattedAmount = amount;
    if (typeof amount === 'number') {
        if (round) {
            formattedAmount = Math.round(amount);
        } else {
            formattedAmount = amount.toFixed(2);
        }
    }
    return (
        formattedAmount
            ?.toString()
            ?.replace('.', ',')
            ?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') ?? 0
    );
};
